import {
    PieChart,
    Pie,
    Cell,
    ResponsiveContainer,
    Tooltip,
    Legend,
} from "recharts";

const DEFAULT_COLORS = [
    "#0c5b67",
    "#30808c",
    "#7ab2ba",
    "#a8d0d6",
    "#d4a373",
    "#ccd5ae",
    "#e9edc9",
    "#faedcd",
];

const PieChartGraph = ({
    data,
    activeTab,
    nameKey = "name",
    valueKey = "value",
    colors = DEFAULT_COLORS,
    height = 320,
}) => {
    const getDisplayData = () => {
        if (Array.isArray(data)) {
            return data;
        }

        if (data && activeTab && Array.isArray(data[activeTab])) {
            return data[activeTab];
        }

        if (data && typeof data === "object") {
            const firstKey = Object.keys(data)[0];

            if (firstKey && Array.isArray(data[firstKey])) {
                return data[firstKey];
            }
        }

        return [];
    };

    const displayData = getDisplayData()
        .map((item) => ({
            ...item,
            [nameKey]: item?.[nameKey] ?? "Sin nombre",
            [valueKey]: Number(item?.[valueKey] ?? 0),
        }))
        .filter((item) => item[valueKey] > 0);

    console.log("Datos para PieChart:", displayData);

    if (!displayData.length) {
        return (
            <div
                style={{
                    width: "100%",
                    minHeight: height,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#777",
                    fontSize: "14px",
                }}
            >
                No hay datos disponibles
            </div>
        );
    }

    const renderCustomLabel = ({
        cx,
        cy,
        midAngle,
        outerRadius,
        percent,
        value,
        payload,
    }) => {
        const RADIAN = Math.PI / 180;

        // Aleja la etiqueta del gráfico
        const radius = outerRadius + 28;

        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        const name = payload?.[nameKey] ?? "Sin nombre";

        // Opcional: no mostrar labels de porciones muy pequeñas
        if (percent < 0.04) return null;

        return (
            <text
                x={x}
                y={y}
                fill="#333"
                textAnchor={x > cx ? "start" : "end"}
                dominantBaseline="central"
                fontSize={14}
                fontWeight={600}
            >
                {`${name}: ${Number(value).toFixed(1)}%`}
            </text>
        );
    };

    return (
        <div
            style={{
                width: "100%",
                height,
                minHeight: height,
                position: "relative",
            }}
        >
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                    <Pie
                        data={displayData}
                        cx="50%"
                        cy="50%"
                        innerRadius={65}
                        outerRadius={95}
                        paddingAngle={5}
                        dataKey={valueKey}
                        nameKey={nameKey}
                        label={renderCustomLabel}
                        labelLine={false}
                    >
                        {displayData.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={colors[index % colors.length]}
                            />
                        ))}
                    </Pie>

                    <Tooltip
                        formatter={(value, name) => [
                            `${Number(value).toFixed(2)}%`,
                            name,
                        ]}
                        contentStyle={{
                            backgroundColor: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            fontSize: "14px",
                        }}
                    />

                    <Legend
                        wrapperStyle={{
                            fontSize: "14px",
                            color: "#666",
                            paddingTop: "10px",
                        }}
                    />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
};

export default PieChartGraph;
